import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=673a47b6&"
import script from "./icon-button.vue?vue&type=script&lang=ts&"
export * from "./icon-button.vue?vue&type=script&lang=ts&"
import style0 from "./icon-button.vue?vue&type=style&index=0&id=673a47b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports